import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AppSnackBaseComponent } from '../../../shared/components/snacks/snack-base.component';
import { Router } from '@angular/router';

export interface InsightsLibraryCopiedSnackData {
  itemName: string;
  destination: string;
  link: string;
};

@Component({
  selector: 'app-insights-library__copied-snack',
  template: `
    <div class="text-center">
      <div class="fs-16">
        <strong>{{data.itemName}}</strong><span> has been copied to </span><strong>{{data.destination}}</strong>
      </div>
      <div *ngIf="data.link" class="fs-16 mt-6 c-blue">
        <a class="snack-link underline bold pointer" [href]="data.link" target="_blank">
          <i class="fas fa-reply mr-6"></i><span>Go to {{data.destination}}</span>
        </a>
      </div>
    </div>`,
  encapsulation: ViewEncapsulation.None,
  host: { 'class': 'mat-simple-snackbar' },
  standalone: false
})
export class InsightsLibraryCopiedSnack extends AppSnackBaseComponent {
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    snackBarRef: MatSnackBarRef<InsightsLibraryCopiedSnack>,
    @Inject(MAT_SNACK_BAR_DATA) public data: InsightsLibraryCopiedSnackData,
    readonly router: Router) {
    super(changeDetectorRef, snackBarRef);
  }

  async openLink() {
    this.dismiss();
    await this.router.navigateByUrl('/', { skipLocationChange: true });
    await this.router.navigateByUrl(this.data.link);
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
};
